/* Import Modules */
import $ from "jquery";
import { ref } from "vue";
/* Import Variables */
import { userEditForm } from "../variables";
/* Import Script */

/* Define Variables. */
export const scheduleUserEditModalRef = ref<any>(null);

/* Define Functions. */
export const showSheduleUserEditModal = async (users: object, id: number) => {
  let userArray = Array();
  await $.each(users, function (index: any, value: any) {
    userArray.push(value.id);
  });

  userEditForm.id = id;
  userEditForm.users = userArray;
  scheduleUserEditModalRef.value?.showModal();
};

export const hideScheduleUserEditModal = () => {
  userEditForm.id = 0;
  userEditForm.users = Array();
  scheduleUserEditModalRef.value?.hideModal();
};
